export const pdfContentType = 'application/pdf';
export const pdfExtension = 'pdf';
